export function StepsIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.77833 11.1667C4.49016 11.6649 3.95154 12.0001 3.33464 12.0001C2.41416 12.0001 1.66797 11.2539 1.66797 10.3334C1.66797 9.41294 2.41416 8.66675 3.33464 8.66675C3.95154 8.66675 4.49016 9.00191 4.77833 9.50008H8.55761C8.84578 9.00191 9.3844 8.66675 10.0013 8.66675C10.6182 8.66675 11.1568 9.00191 11.445 9.50008H15.2243C15.5124 9.00191 16.0511 8.66675 16.668 8.66675C17.5884 8.66675 18.3346 9.41294 18.3346 10.3334C18.3346 11.2539 17.5884 12.0001 16.668 12.0001C16.0511 12.0001 15.5124 11.6649 15.2243 11.1667H11.445C11.1568 11.6649 10.6182 12.0001 10.0013 12.0001C9.3844 12.0001 8.84578 11.6649 8.55761 11.1667H4.77833Z"
        fill="currentColor"
      />
    </svg>
  );
}
